import FeedContentPage from "../components/feed/FeedContentPage";

const  FeedPage = () => {
  return <FeedContentPage/>;
};

export default FeedPage;
